import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=71b615d7&scoped=true&"
import script from "./page404.ts?vue&type=script&lang=ts&"
export * from "./page404.ts?vue&type=script&lang=ts&"
import style0 from "./Page404.vue?vue&type=style&index=0&id=71b615d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b615d7",
  null
  
)

export default component.exports